import type { MarketSettings } from '../marketSettings'
export type { MarketSetting, MarketSettings } from '../marketSettings'
export const marketSettings: MarketSettings = {
  default: {
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  it: {
    marketId: 'BgVmRheZVj',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 300000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'MWZdswDYyk',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  au: {
    marketId: 'BowdGhRQQj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_RE40S0lZOXFDV3U2TGx0UnAhSjRCZm5DZXM0IWFTenUsOTNlYzg0ODQtMmNkNS00NDY3LTk1ZDItMGEzMGIyOGViNmFhLDEsZzZHKzA2Ui9qd0hreFcyN2ZXYVZxL0YxQ3g5WkRXcHY4R0pCckZvTkUvUT0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  at: {
    marketId: 'BlydJhDnYg',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 100000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'klGasOLOKm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  be: {
    marketId: 'MlpRDheBPj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mVXLsnRnNM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  bg: {
    marketId: 'aoXOBhYdvl',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mAeGsXyXym',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  hr: {
    marketId: 'vlzmJhkWVg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mdjPsgogQM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  cz: {
    marketId: 'qlANwhmPqo',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EJjesAJABE',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  dk: {
    marketId: 'DomJOhGEej',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 5000000,
    klarnaBNPLMaxPriceCents: 5000000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mRQlsvGvBE',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  us: {
    marketId: 'KoaJYhAZaj',
    region: 'US',
    max_MFCS: 5,
    max_cart: 15,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 100000,
    klarnaPlacementKey:
      'klarna_live_client_SXNUOFd1NHU0V3loRy1aRWQyUTFLcTlldDMzI3B6RlAsOGVmOTY0ZGMtM2MzNy00MzBhLTk0MGYtNTEzZmY2YmMzZDEwLDEsZ2ptNXFvVjlBWTFCMmxQQ0p2TDlhU05YWU5xaU1sZUQycWZ3L21lS3Zwaz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  ee: {
    marketId: 'vlGRmhOLdg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'kroVsayaRM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  fi: {
    marketId: 'ElJGehaeEo',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mPKdsDqDeE',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  fr: {
    marketId: 'rlEPzhXEPg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 150000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EbqRsJyoYM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  de: {
    marketId: 'GoeMQhyawo',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 100000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'MpLasNwYNM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  gr: {
    marketId: 'qoLdBhJrBo',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 100000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'kNJesejJJk',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  hu: {
    marketId: 'XlBdyhVwBj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'MLyeszbeYE',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  ie: {
    marketId: 'YoZRDhKARo',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 150000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mYwBsvDRQM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  lv: {
    marketId: 'VgKNLhGbAj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EoLasALaOm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  lt: {
    marketId: 'xodbQhwMEg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EKLesNAjam',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  lu: {
    marketId: 'wlvKBhYGNo',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mGGzsdbyBm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  nl: {
    marketId: 'YgPmehOpYl',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 400000,
    klarnaBNPLMaxPriceCents: 400000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mnVasLnbBm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  pl: {
    marketId: 'ElDkXhpZDg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EXeWsoRXqm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  pt: {
    marketId: 'djQbPhZKQg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 100000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EawJsdVgxk',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  sk: {
    marketId: 'AlRevhKbag',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'kyvxsPoYxM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  si: {
    marketId: 'AonEVhJNVl',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'EjPasNXGwk',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  es: {
    marketId: 'VgWXOhwYWl',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 150000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mvVesJeOYm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  se: {
    marketId: 'dgrVZhBdBg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 3600000,
    klarnaBNPLMaxPriceCents: 3600000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'meydsnWQBm',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  ch: {
    marketId: 'QlNQVherzg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'MBvQsOqpWM',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  gb: {
    marketId: 'YlqxGhLQng',
    region: 'EU',
    max_MFCS: 4,
    max_cart: 20,
    paypalBNPLMaxPriceCents: 200000,
    klarnaBNPLMaxPriceCents: 200000,
    klarnaPlacementKey:
      'klarna_live_client_OVhRRXdKL3hiKFN6Zy8pb1hlN2MpMGFGY1owVFQpZUMsZDViZjk2M2YtNjgyMC00ODRiLTkwMTItZGY3NDNiNTYwMzM4LDEsR3dqTHF4eTU4cTZyVkRLbCtKbHZHdVNWUWpoWFFidEludkxnMTFRTWdTQT0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'mAeGsXyDym',
      clientId:
        'AYtY7q5zyGw_YxolGbnKb0RVZQjzlazM5h4HLKo0TLZ1383OnEg3nDHFnzeghzkFTed2vGjfjdFINEsx',
    },
  },
  ca: {
    marketId: 'dgrVZhBNbg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  cl: {
    marketId: 'QlNQVheaeg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  hk: {
    marketId: 'YlqxGhLaqg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  id: {
    marketId: 'bgOEQhLRko',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  il: {
    marketId: 'vlkaZhbXxj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  nz: {
    marketId: 'pgMvehEPJl',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  ph: {
    marketId: 'JlYxVhGMKg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  ro: {
    marketId: 'BlxrJhDXEj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: true,
    paypalExpress: {
      paymentMethodId: 'kZLZsBZjLE',
      clientId:
        'AVl-payCoe5Q7BC5pproKt4XVSoVDRHSJa_h_kYAvwqMd6R7X63uX_1DzX6gFimCIo3zAiIei8eQ9xF-',
    },
  },
  sg: {
    marketId: 'BgVmRheqmj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  za: {
    marketId: 'BowdGhRnzj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    paypalBNPLMaxPriceCents: 250000,
    klarnaBNPLMaxPriceCents: 200000,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  kr: {
    marketId: 'BlydJhDWrg',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  tw: {
    marketId: 'MlpRDherBj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  th: {
    marketId: 'aoXOBhYwMl',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  jp: {
    marketId: 'vlzmJhkVAg',
    region: 'JP',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  tr: {
    marketId: 'qlANwhmnBo',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  my: {
    marketId: 'DomJOhGMMj',
    region: 'EU',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  wx: {
    marketId: 'vlzmJhYAAg',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  in: {
    marketId: 'oLdBhVAbWo',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  al: {
    marketId: 'lBdyhaZQpj',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  ae: {
    marketId: 'oZRDhLPMyo',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  sa: {
    marketId: 'gKNLhMzAaj',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
  eg: {
    marketId: 'odbQhAYrOg',
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    klarnaPlacementKey:
      'klarna_live_client_Tkw3KHJTNTVpWCk1c3k1QTczRUFFclhqd3o3OVd1TWgsMTRmNWQ3MGQtZjNlYy00YmZhLTg3NmItZWNhZGFmNzRjOTc1LDEsNjdGQ2l5Z3ZyUVgrbllWUlBtRUpIeHVRKzRKeTN5N2VoSkthNEc5dE9Vbz0',
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  },
}
